module.exports = __webpack_public_path__ + "assets/img/robyn_searle.8e059121.jpg";